import * as React from "react";
import { useKnockFeed } from "../KnockFeedProvider";
import { CheckmarkCircle } from "../Icons";
export var MarkAsRead = _ref => {
  var {
    onClick
  } = _ref;
  var {
    useFeedStore,
    feedClient,
    colorMode
  } = useKnockFeed();
  var unreadItems = useFeedStore(state => state.items.filter(item => !item.read_at));
  var unreadCount = useFeedStore(state => state.metadata.unread_count);
  var onClickHandler = React.useCallback(e => {
    feedClient.markAsRead(unreadItems);
    if (onClick) onClick(e, unreadItems);
  }, [feedClient, unreadItems, onClick]);
  return /*#__PURE__*/React.createElement("button", {
    className: "rnf-mark-all-as-read rnf-mark-all-as-read--".concat(colorMode),
    disabled: unreadCount === 0,
    onClick: onClickHandler
  }, "Mark all as read", /*#__PURE__*/React.createElement(CheckmarkCircle, null));
};
//# sourceMappingURL=MarkAsRead.js.map